import axios from 'axios'
import { Notification, MessageBox, Message } from 'element-ui'
import { getToken, removeToken } from '@/utils/auth'
import { encrypt, decrypt } from '@/utils/crypto'
import errorCode from '@/utils/errorCode'
import swal from 'sweetalert';


axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
axios.defaults.headers['Access-Control-Allow-Origin'] = 'http://localhost:88/'
// 创建axios实例
const service = axios.create({
    // axios中请求配置有baseURL选项，表示请求URL公共部分
    baseURL: process.env.VUE_APP_BASE_API,
    // 超时
    timeout: 60000
})
// request拦截器
service.interceptors.request.use(config => {
    // 是否需要设置 token
    const isToken = (config.headers || {}).isToken === false
    if (getToken() && !isToken) {
        config.headers['Authorization'] = 'Bearer ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    // 请求体加密（非 GET 且为 JSON 对象，附件 FormData 跳过）
    if (config.method && config.method.toLowerCase() !== 'get'
        && config.data && typeof config.data === 'object' && !(config.data instanceof FormData)) {
        config.data = encrypt(JSON.stringify(config.data))
        config.headers['X-Encrypted'] = 'true'
    }
	return config
}, error => {
   // // console.log(error)
    Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
	// console.log("响应拦截res==>",res);

        // 响应体解密（后端带 X-Encrypted 头的加密响应）
        if (res.headers && (res.headers['x-encrypted'] === 'true' || res.headers['X-Encrypted'] === 'true')
            && typeof res.data === 'string') {
            try {
                res.data = JSON.parse(decrypt(res.data))
            } catch (e) {
                // 解密失败保留原样
            }
        }

        // 未设置状态码则默认成功状态
        const code = res.data.code || 200;
        // 获取错误信息
        const message = errorCode[code] || res.data.msg || errorCode['default']
        if (code === 401) {
			localStorage.clear();
			removeToken();
			let url =
				"https://zwfw.sd.gov.cn/JIS/front/login.do?uuid=9HOFE5P1Gznq&redirectUrl=https://zhjg.weihai.cn/api/tydlGetTicket";
			window.location.href = url;
        } else if (code === 500) {
			swal( "", message,"error",{button: false,timer: 2000});
            return Promise.reject(new Error(message))
        } else if (code !== 200) {
            Notification.error({
                title: message
            })
            return Promise.reject('error')
        } else {
            return res.data
        }
    },
    error => {
        Message({
            message: error.message,
            type: 'error',
            duration: 5 * 1000
        })
        return Promise.reject(error)
    }
)

export default service
